import { render } from "./SeparateMessage.vue?vue&type=template&id=45be6f02&scoped=true"
import script from "./SeparateMessage.vue?vue&type=script&lang=js"
export * from "./SeparateMessage.vue?vue&type=script&lang=js"

import "./SeparateMessage.vue?vue&type=style&index=0&id=45be6f02&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45be6f02"]])

export default __exports__